// Dependencies
import React, { Component } from "react";
import ReactHtmlRender from "react-html-parser";
// Components & Containers
import "./style.css";

export default class Quote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: undefined || props.title,
      author: props.author || ``,
      description: undefined || props.description
    };
  }

  shouldComponentUpdate = nextProps => {
    const { title, description, author } = this.state;
    if (
      title !== nextProps.title ||
      description !== nextProps.description ||
      author !== nextProps.author
    ) {
      this.setState({
        title: nextProps.title,
        description: nextProps.description,
        author: nextProps.author
      });
    }
    return true;
  };

  render() {
    const { title, author, description } = this.state;
    return (
      <section className="quote2" id="quote2">
        <div className="quote2__title">{title}</div>
        <div className="quote2__subtitle">{`- ${author} -`}</div>
        <div className="quote2__container">
          <p className="quote2__content">{ReactHtmlRender(description)}</p>
          <div className="quote2__imgBox">
            <img className="quote2__imgBox__img" src="SteveHanke.jpeg" alt="" />
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Quote2/index.jsx